module.exports = __webpack_public_path__ + "img/banner.194e04d7.png";